import { Box, IconButton, Popover, Typography } from '@mui/material';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { DateCalendar } from '@mui/x-date-pickers';
import { useState } from 'react';
import { formatDate } from '../../utils';
import { useAtom } from 'jotai';
import * as kpiState from '../../state';

export const KpiDatePicker = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedDate, setSelectedDate] = useAtom(kpiState.selectedDate);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDateChange = (newDate: Date | null) => {
    if (newDate) {
      setSelectedDate(newDate);
      handleClose();
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Typography color="primary.light">Against the date:</Typography>
      <Box
        onClick={handleOpen}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          cursor: 'pointer',
          border: '1px solid',
          borderColor: 'text.secondary',
          px: 1,
        }}
      >
        <Typography variant="h4" sx={{ fontSize: '1.5rem', color: 'primary.main' }}>
          {formatDate(selectedDate)}
        </Typography>
        <IconButton size="small" sx={{ p: 0.5 }} id="kpi-tracker-date-selection-button">
          <CalendarTodayOutlinedIcon sx={{ color: 'text.primary', fontSize: 20 }} />
        </IconButton>
      </Box>
      <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleClose}>
        <DateCalendar value={selectedDate} onChange={handleDateChange} disableFuture />
      </Popover>
    </Box>
  );
};
